<script lang="ts">
  import {navigateTo, router} from 'yrv';
  import InlineSVG from 'svelte-inline-svg';

  import {
    EDIT_PROJECT_REGEX,
    LIST,
    NEW_PROJECT_REGEX
  } from '../../constants/views';

  import {filterQueryParameters} from '../../stores/filter-and-sort';

  import backIcon from '../../assets/icons/arrow-left.svg';

  import IconButton from '../icon-button/IconButton.svelte';
  import Modal from '../modal/Modal.svelte';

  // Get query parameters from filters in store
  $: queryParams = Object.fromEntries(
    Object.entries($filterQueryParameters).filter(
      ([_, value]) =>
        value != null && value !== '' && (!Array.isArray(value) || value.length)
    )
  );

  let showConfirmModal = false;

  const handleBackButtonClick = () => {
    if (
      (NEW_PROJECT_REGEX.test($router.path) ||
        EDIT_PROJECT_REGEX.test($router.path)) &&
      $router.query.changed
    ) {
      showConfirmModal = true;
    } else {
      navigateTo(LIST, {queryParams});
    }
  };

  let {path} = $router;
  // query parameter 'changed' is added when user changes form data
  let {changed} = $router.query;

  // Show confirm modal if user tries to navigate away from form using browser buttons
  router.subscribe(router => {
    const isNewProjectPath =
      NEW_PROJECT_REGEX.test(path) && NEW_PROJECT_REGEX.test(router.path);
    const isEditProjectPath =
      EDIT_PROJECT_REGEX.test(path) && EDIT_PROJECT_REGEX.test(router.path);
    if (
      (isNewProjectPath || isEditProjectPath) &&
      // former path contained 'changed' query parameter
      changed &&
      !router.query.changed
    ) {
      showConfirmModal = true;
      navigateTo(router.path, {
        replace: false,
        reload: true,
        params: router.params,
        // Re-add 'changed' query parameter
        queryParams: {...router.query, changed: true}
      });
    }
    path = router.path;
    changed = router.query.changed;
  });
</script>

<style lang="postcss">
  @media (min-width: 768px) {
    :global(nav > button.backButton) {
      --ubilabs-icon-button-icon-size: 1.5rem;
      box-shadow: 0 1px 2px rgba(var(--ubilabs-black-rgb), 0.14),
        0 1px 2px rgba(var(--ubilabs-black-rgb), 0.12);
      background-color: var(--ubilabs-gray-light);
    }
  }
</style>

{#if showConfirmModal}
  <Modal
    actions={[
      {label: 'Cancel', clickHandler: () => (showConfirmModal = false)},
      {label: 'Confirm', clickHandler: () => navigateTo(LIST, {queryParams})}
    ]}
    modalTitle="Unsaved changes"
    onBackdropClick={null}
    content="Do you want to close the form without saving?" />
{/if}

<IconButton
  class="backButton {$$props.class}"
  on:click={handleBackButtonClick}
  title="Back"
  aria-label="Back">
  <InlineSVG src={backIcon} />
</IconButton>
